<template>
  <div class="admin-layout">
    <!-- Sidebar -->
    <SidebarAdmin />

  <section class="main-content">
      <header class="page-header">
        <h2>👥 Liste des clients</h2>
        <p class="subtitle">Consultez les informations des clients inscrits sur la plateforme</p>
      </header>

      <!-- Barre de recherche -->
      <div class="filter-bar">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="🔍 Rechercher un client (nom, email...)"
          class="search-input"
        />
      </div>

      <!-- Tableau des clients -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Nom</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Ville</th>
              <th>Date d'inscription</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(client, index) in paginatedClients"
              :key="client._id"
            >
              <td>{{ index + 1 + (currentPage - 1) * itemsPerPage }}</td>
              <td>{{ client.prenom }} {{ client.nom }}</td>
              <td>{{ client.email }}</td>
              <td>{{ client.telephone || "-" }}</td>
              <td>{{ client.ville || "-" }}</td>
              <td>{{ formatDate(client.createdAt) }}</td>
              <td class="action-buttons">
                <button class="btn-details" @click="viewClient(client)">Détails</button>
                <button class="btn-delete" @click="deleteClient(client._id)">Supprimer</button>
              </td>
            </tr>

            <tr v-if="paginatedClients.length === 0">
              <td colspan="7" class="no-data">Aucun client trouvé.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1">⬅️</button>
        <span>Page {{ currentPage }} / {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage === totalPages">➡️</button>
      </div>

      <!-- Modale Détails -->
      <div v-if="selectedClient" class="modal-overlay" @click.self="selectedClient = null">
        <div class="modal">
          <h3>👤 Informations du client</h3>
          <p><strong>Nom :</strong> {{ selectedClient.prenom }} {{ selectedClient.nom }}</p>
          <p><strong>Email :</strong> {{ selectedClient.email }}</p>
          <p><strong>Téléphone :</strong> {{ selectedClient.telephone || "—" }}</p>
          <p><strong>Adresse :</strong> {{ selectedClient.adresse || "—" }}</p>
          <p><strong>Ville :</strong> {{ selectedClient.ville || "—" }}</p>
          <p><strong>Date d’inscription :</strong> {{ formatDate(selectedClient.createdAt) }}</p>
          <div class="modal-actions">
            <button class="btn-cancel" @click="selectedClient = null">Fermer</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SidebarAdmin from "@/views/admin/SidebarAdmin.vue";
import axios from "axios";

export default {
  name: "ClientsPage",
  components: { SidebarAdmin },
  data() {
    return {
      clients: [],
      searchQuery: "",
      selectedClient: null,
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    filteredClients() {
      return this.clients.filter((c) =>
        `${c.nom} ${c.prenom} ${c.email}`
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.filteredClients.length / this.itemsPerPage);
    },
    paginatedClients() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredClients.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    async fetchClients() {
      try {
        const res = await axios.get("http://localhost:2028/api/users");
        this.clients = res.data.filter((u) => u.role === "account");
      } catch (err) {
        console.error("Erreur lors du chargement des clients :", err);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "—";
      return new Date(dateStr).toLocaleDateString("fr-FR");
    },
    viewClient(client) {
      this.selectedClient = client;
    },
    async deleteClient(id) {
      if (confirm("Voulez-vous vraiment supprimer ce client ?")) {
        try {
          await axios.delete(`http://localhost:2028/api/users/${id}`);
          this.clients = this.clients.filter((u) => u._id !== id);
          alert("✅ Client supprimé avec succès !");
        } catch (err) {
          console.error("Erreur de suppression :", err);
          alert("❌ Erreur lors de la suppression du client.");
        }
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  mounted() {
    this.fetchClients();
  },
};
</script>

<style scoped>
/* === LAYOUT === */
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: "Poppins", sans-serif;
  transition: background 0.3s ease, color 0.3s ease;
}

.main-content {
  flex: 1;
  padding: 40px;
  background: #ffffff;
  border-radius: 0 16px 16px 0;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
  transition: background 0.3s ease, color 0.3s ease;
}

/* === HEADER === */
.page-header {
  margin-bottom: 25px;
}
.page-header h2 {
  font-size: 24px;
  color: #00998b;
  margin-bottom: 5px;
}
.subtitle {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

/* === BARRE RECHERCHE === */
.filter-bar {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
.search-input {
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.25s ease;
}
.search-input:focus {
  border-color: #00998b;
  box-shadow: 0 0 0 3px rgba(0, 153, 139, 0.15);
}

/* === TABLEAU === */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
}
table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
th,
td {
  padding: 14px 18px;
  border-bottom: 1px solid #eee;
  text-align: left;
  font-size: 14px;
  color: #222;
  white-space: nowrap;
}
th {
  background-color: #f8f9fa;
  color: #333;
  text-transform: uppercase;
  font-weight: 600;
}

/* === ACTIONS === */
.action-buttons {
  display: flex;
  gap: 10px;
}
.btn-details {
  background-color: #5a5858;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}
.btn-details:hover {
  background-color: #131618;
}
.btn-delete {
  background-color: #666565;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}
.btn-delete:hover {
  background-color: #b91c09;
}

/* === MODALE === */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  text-align: left;
}
.modal h3 {
  margin-bottom: 15px;
  color: #00998b;
}
.modal p {
  margin-bottom: 8px;
  color: #333;
}
.modal-actions {
  text-align: right;
  margin-top: 20px;
}
.btn-cancel {
  background: #ccc;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

/* === MODE SOMBRE === */
@media (prefers-color-scheme: dark) {
  .admin-layout {
    background: #0f1720;
  }
  .main-content {
    background: #1a2532;
    color: #e6edf1;
  }
  .page-header h2 {
    color: #00c8b3;
  }
  table {
    background: #1f2b3a;
  }
  th {
    background: #253444;
    color: #e6edf1;
  }
  td {
    border-bottom: 1px solid #2e3d4d;
    color: #e1e8ed;
  }
  .search-input {
    background: #24313f;
    color: #e6edf1;
    border-color: #3a4a5b;
  }
  .btn-details {
    background-color: #626465;
    
  }
  .btn-delete {
    background-color: #5a5858;
  }
  .modal {
    background: #263342;
    color: #e6edf1;
  }
  .modal p {
  margin-bottom: 8px;
  color: #fff;
}
}

/* Garde ton style original + pagination harmonisée */
.pagination {
  margin-top: 15px;
  text-align: center;
}

.pagination button {
  background: #00998b;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  margin: 0 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.pagination button:hover:not(:disabled) {
  background: #007c71;
}

.pagination button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.no-data {
  text-align: center;
  color: #888;
  font-style: italic;
}

/* Mode sombre */
@media (prefers-color-scheme: dark) {
  .pagination button {
    background: #00bfa5;
  }

  .no-data {
    color: #aaa;
  }
}

</style>
